/* src/app/footer/footer.component.scss */
.content {
  margin: 10px;
  justify-content: space-between;
}
.bottom {
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.122);
}
.bottom ul {
  margin: 0 auto;
}
.bottom li {
  float: left;
  padding: 5px 10px;
  margin: 5px;
}
li a:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=footer.component.css.map */
